import { mapEnumToOptions } from '@abp/ng.core';

export enum TicketEducationKind {
  Course = 0,
  Document = 1,
  Bundle = 2,
}

export const ticketEducationKindOptions = mapEnumToOptions(TicketEducationKind);
